import YogaMatIcon from "@/assets/icons/yoga-mat.svg";
import BandageIcon from "@/assets/icons/bandage-1.svg";
import DumbbellDiskIcon from "@/assets/icons/Fitness-dumbbell-disk-weight.svg";
import SlimWaistIcon from "@/assets/icons/slim-waist.svg";
import SportRingsIcon from "@/assets/icons/sport-rings.svg";
import TrainingHeartIcon from "@/assets/icons/training-session-heart.svg";
import MatTrainingYogaIcon from "@/assets/icons/mat-training-yoga.svg";
import RunningIcon from "@/assets/icons/running.svg";

export const PROGRAM_CATEGORIES = [
  "Schmerzlinderung",
  "Kräftigung",
  "Beweglichkeit",
  "Koordination",
  "Prävention",
  "Entspannung",
  "Ausdauer",
];

const GOAL_TO_CATEGORY = {
  "1": "Schmerzlinderung",
  "2": "Kräftigung",
  "3": "Beweglichkeit",
  "4": "Koordination",
  "5": "Prävention",
  "6": "Entspannung",
  "7": "Ausdauer",
};

const CATEGORY_ICON_MAP = {
  Schmerzlinderung: BandageIcon,
  Kräftigung: DumbbellDiskIcon,
  Beweglichkeit: SlimWaistIcon,
  Koordination: SportRingsIcon,
  Prävention: TrainingHeartIcon,
  Entspannung: MatTrainingYogaIcon,
  Ausdauer: RunningIcon,
};

const normalizeCategoryLabel = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return null;

  if (raw.includes("schmerz")) return "Schmerzlinderung";
  if (raw.includes("kräft") || raw.includes("kraft")) return "Kräftigung";
  if (raw.includes("beweg")) return "Beweglichkeit";
  if (raw.includes("koord")) return "Koordination";
  if (raw.includes("prävent") || raw.includes("praevent")) return "Prävention";
  if (raw.includes("entspann")) return "Entspannung";
  if (raw.includes("ausdau")) return "Ausdauer";

  return null;
};

const extractGoalId = (program) => {
  const rawGoal =
    program?.goal_id ??
    program?.goalId ??
    (typeof program?.goal === "object" ? program.goal?.id : program?.goal) ??
    "";
  return String(rawGoal || "").trim();
};

const hashString = (text) => {
  const source = String(text || "");
  let hash = 0;
  for (let i = 0; i < source.length; i += 1) {
    hash = (hash << 5) - hash + source.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getProgramCategory = (program) => {
  if (!program) return "Schmerzlinderung";

  const goalId = extractGoalId(program);
  if (GOAL_TO_CATEGORY[goalId]) return GOAL_TO_CATEGORY[goalId];

  const directCategory =
    normalizeCategoryLabel(program.category) ||
    normalizeCategoryLabel(program.program_category) ||
    normalizeCategoryLabel(program.goal) ||
    normalizeCategoryLabel(program.target);
  if (directCategory) return directCategory;

  const fromName = normalizeCategoryLabel(program.name);
  if (fromName) return fromName;

  const seed = `${program.id || ""}-${program.program_code || ""}-${program.name || ""}`;
  const idx = hashString(seed) % PROGRAM_CATEGORIES.length;
  return PROGRAM_CATEGORIES[idx];
};

export const getCategoryIcon = (category) =>
  CATEGORY_ICON_MAP[category] || YogaMatIcon;

